import ChooseAvatarOption from './ChooseAvatarOption'

export default ChooseAvatarOption



// WEBPACK FOOTER //
// ./src/app/elements/ChooseAvatarOption/index.js